import { RemoveScroll } from "react-remove-scroll";

export const REMOVE_SCROLL_CLASS_NAMES = RemoveScroll.classNames;
